import * as React from 'react';
import { useEffect, useState } from 'react';

import { FormattedMessage } from 'react-intl';
import { toShortSemanticVersion } from '~/features/base/utils/versionNumberConverter';
import { useLazyFetchDeliverableVersionsQuery } from '~/api/deliverables/DeliverablesManagement.api';
import { DeliverableSearchCriteriaDeliverableTypeEnum } from '~/api/models/deliverable-search-criteria';
import { UNKNOWN } from '~/features/base/constants/filterOptions';
import { CM4 } from '~/features/devices/constants/deviceTypes';
import { LastReportedEssentialImage } from '~/api/models/bundle';
import MultiSelectOTA from '~/features/base/components/forms/ota/MultiselectOTA';

interface EssentialImageFormItemProps {
    value?: string[];
    onChange: (versions: string[]) => void;
}



const EssentialImageFormItem = ({ value, onChange }: EssentialImageFormItemProps) => {

    const [essentialImageVersions, setEssentialImageVersions] = useState<{
        label: string | React.JSX.Element,
        value?: string,
        id: string
    }[]>();


    const [getDeliverableVersions] = useLazyFetchDeliverableVersionsQuery();

    useEffect(() => {
        getVersions('essential-image', DeliverableSearchCriteriaDeliverableTypeEnum.BUNDLE);
    }, []);



    const getVersions = (deliverableId = '', deliverableType = '') => {
        getDeliverableVersions({ deliverableId, deliverableType }, true).then(result => {
            const versionsList = result?.data?.content.map(version => {
                return {
                    label: toShortSemanticVersion(version),
                    value: toShortSemanticVersion(version),
                    id: toShortSemanticVersion(version)
                };

            });
            versionsList && setEssentialImageVersions([{
                label: UNKNOWN,
                value: UNKNOWN,
                id: UNKNOWN
            }, ...versionsList]);

        });
    };

    const handleOnchange = (versions) => {
        onChange(versions || []);
    }
    return (
        <div className='form-group-semantic-version-range display-flex flex-row '>
            <div className='flex-basis-100pct'>
                <MultiSelectOTA
                    labelId='intl-msg:lastReportedEssentialImage.version'
                    options={essentialImageVersions?.map(v => v.value) || []}
                    value={value || []}
                    onChange={handleOnchange}/>
            </div>
        </div>
    );

};

export default EssentialImageFormItem;
